<template>
  <div class="row">
      <div class="col-md-12 col-xxl-12 col-sm-12 mb-10">
        <div class="card mb-25 border-0 rounded-0">
          <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
            <div class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
              <router-link to="/liste-services" 
              class=" btn btn-primary transition border-0 lh-1 fw-medium" >
              <i class="flaticon-left-arrow  lh-1 me-1 position-relative top-2"></i>
              <span class="position-relative"></span>Retour</router-link>
              
            </div>
            <table class="table">
              <tbody>
                <tr v-if="categorieArticles?.urlImage">
                  <td class="bl">Icône :</td>
                  <td><img :src="getUrlApiForFiles(categorieArticles.urlImage)" alt="Image" width="200" height="200"></td>
                </tr>
                <!-- <tr v-if="categorie?.nom">
                  <td class="bl">Nom :</td>
                  <td>{{ categorie?.nom }}</td>
                </tr> -->
                <!-- <tr v-if="categorie?.code">
                  <td class="bl">Code:</td>
                  <td>{{ categorie?.code }}</td>
                </tr> -->
                <td class="bl">Type de Service :</td>
                <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <span v-if="categorieArticles?.typeCategorie === 1">Service Interne</span>
                <span v-if="categorieArticles?.typeCategorie === 0">Service Externe</span>

              </td>
                <tr v-if="categorieArticles?.description">
                  <td class="bl">Description :</td>
                  <td v-html="categorieArticles.description"></td>
                </tr>
                <!-- <tr>
                  <td class="bl">Service :</td>
                  <td>
                    <span class="badge text-outline-info">{{categorie?.isService}}</span> -->
                    <!-- <span v-if="categorie?.isService === true" class="badge text-outline-info">Oui</span>
                    <span v-if="categorie?.isService === false" class="badge text-outline-danger">Non</span> 
                  </td>
                </tr> -->
                <!-- <tr v-if="categorie?.categorieArticle">
                  <td class="bl">Sous catégorie:</td>
                  <td> {{ categorie?.categorieArticle?.nom}}
                  </td>
                </tr> -->
                <!-- <tr v-if="categorie">
                  <td class="bl">Lien :</td>
                  <td> {{ categorie?.lienExterne}}
                  </td>
                </tr> -->
              </tbody>
            </table>
          </div>
        </div>
      </div>


  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import { error, format_date,separateur,format_Date, getUrlApiForFiles } from "@/utils/utils";
import { useRoute } from "vue-router";
import { Categorie } from "@/models/Categorie";
import ApiService from "@/services/ApiService";
import {CategorieArticle} from '../../models/CategorieArticle';
import AddCategorieArticle from "../CategorieArticle/AddCategorieArticle.vue";

export default defineComponent({
  name: "ViewCategorie",
  setup: () => {
    const route = useRoute();
    const categorieArticles = ref<Array<CategorieArticle>>([]);
    const categorieArticle = ref<CategorieArticle>();
    function getCategorie(id: string) {
      return ApiService.get("/categorieArticles/"+id)
        .then(({ data }) => {
          categorieArticles.value = data.data; 
          console.log('jeoke', categorieArticles.value);
        })
        .catch(({ response }) => {
          error(response.data.message);
        });
    } 

    onMounted(() => {
      const id = route.params.id as string;
      getCategorie(id);
    });

    return { categorieArticles, getCategorie, format_date,format_Date,separateur,getUrlApiForFiles };
  },
});
</script>

<style>
  .bl{
    font-weight: bold;
  }
</style>